import { render, staticRenderFns } from "./SearchForm.vue?vue&type=template&id=5a2433da&scoped=true&"
import script from "./SearchForm.vue?vue&type=script&lang=js&"
export * from "./SearchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2433da",
  null
  
)

export default component.exports